h = require('./helpers')

class Commission
  applyStyles: ->
    console.log 'Применяю стили Commission'
    $form = $('#aspnetForm')

#    $('body').removeClass().addClass('commission')

    if $('.commission-content').length == 0
      h.h1('Комиссия', 'h1-commission').appendTo $form
      [$row, $wrapper] = h.rowN(true, 'commission-content')
      $form.append $row

      $iframe = $ '<iframe/>',
        src: '//www.tourtrans.ru/ta/comission.html?iframe=1'
      $iframe.appendTo $wrapper

module.exports = new Commission